import React from 'react';
import './notFound.css';

const Notfound = () => <h1 className='notfound'>URL Not found</h1>

export default Notfound